import React from "react";
import AppContext from "./context/AppContext";
import routes from "./routes";
import AuthVerification from "./components/AuthVerification";
import UWEContext from "./context/UWEContext";
import RouteSwitch from "./components/RouteSwitch";
import ChatApp from "./views/ChatApp";
import { REACT_APP_USE_AI } from "./constants";
import { NotificationProvider } from './context/NotificationContext';

function App() {
  return (
    <AppContext.Component>
      <UWEContext.Component>
        <NotificationProvider>
          <AuthVerification />
          {REACT_APP_USE_AI && <ChatApp />}
          <RouteSwitch routes={routes} />
        </NotificationProvider>
      </UWEContext.Component>
    </AppContext.Component>
  );
}

export default App;
